import React from 'react';
import { Button, Modal, message } from "antd";
import { useParams } from 'react-router-dom';
import { deactivateUser } from '../useAPIDetails/useFetchUserList';

const DeactiveUserModal = ({ isModalVisible, setIsModalVisible, userName }) => {
  const { id } = useParams();

  const handleConfirmDeactivation = async() => {
    setIsModalVisible(false);
    try {
      await deactivateUser(id);
      message.success("User deactivate successfully.");
    } catch (err) {
      message.error(err?.response?.data?.message || "Failed to deactivate user");
    }
  };

  const handleCancelDeactivation = () => {
    setIsModalVisible(false);
  };

  return (
    <Modal
      title="Deactivate User"
      open={isModalVisible}
      onOk={handleConfirmDeactivation}
      onCancel={handleCancelDeactivation}
      centered 
      footer={[
        <Button
          className="primary-button"
          variant="solid"
          onClick={handleCancelDeactivation}
        >
          No
        </Button>,
        <Button className="primary-button" onClick={handleConfirmDeactivation}>
          Yes
        </Button>,
      ]}
    >
      <p style={{ marginBottom: "25px" }}>
        Are you sure you want to deactivate this User {userName} {id}?
      </p>
    </Modal>
  );
};

export default DeactiveUserModal;
